
import { useQuery } from '@tanstack/react-query';
import { fetchCurrencyList, fetchExchangeRates } from '@src/api/endpoints/calculator';
import { queryKeys } from '@src/utils/queryKeys';

export const useCurrencyListQuery = () => {
    return useQuery({
        queryKey: queryKeys.calculator.currencyList,
        queryFn: fetchCurrencyList,
        staleTime: 24 * 60 * 60 * 1000, 
        placeholderData: { currencies: {} },
    });
};

export const useExchangeRatesQuery = (
    source: string,
    enabled: boolean = true
) => {
    return useQuery({
        queryKey: queryKeys.calculator.exchangeRates(source),
        queryFn: () => fetchExchangeRates(source),
        enabled: enabled && !!source,
        staleTime: 24 * 60 * 60 * 1000, 
        retry: 1,
    });
};
